const textContents = {
    "startPage": {
        "Finland": { "fin": "suomeksi", "rus": "Финский" },
        "Russia": {"fin": "venäjäksi", "rus": "Русский" },
        "Start": { "fin": "Aloita peli", "rus": "Начать игру" },
        "GameName": { "fin": "Mitä Venäjällä kasvaa?", "rus": "Что растёт в России?" },
        "Welcome": {"fin": "Valitse pelin kieli", "rus": "Выбери язык игры" }
    },
    "topMenu": {
        "NavbarFi": {  "fin": "Su", "rus": "Фи" },
        "NavbarRu": {  "fin": "Ve", "rus": "Ру" },
        "NavbarClose": { "fin": "X", "rus": "X" },
        "NavbarInfo": { "fin": "?", "rus": "?" },
        "GameTitle": { "fin": "Mitä Venäjällä kasvaa?", "rus": "Что растёт в России?" }
    },
    "textGame": {
        "HowToPlay": { "type": "Text", "fin": "Kuinka pelata", "rus": "Как играть" },
        "HowToPlayText": {
            "fin": ["Jokaisessa ruudussa on temaattisia kuvia ", "ja suomen aakkosten kirjain, jolla alkavat kuvien sanat.", "Napsauttamalla mitä tahansa kuvaa kursorilla,", "saat selville sanan nimen.", "Nuolilla ”Takaisin” ja ”Eteenpäin” voit siirtyä toiseen kirjaimeen.", "Sinun ei tarvitse odottaa, ", "kunnes kaikki saman ruudun kuvat ovat auki.", "Pelin kirjaimet on järjestetty satunnaiseen järjestykseen.", "Peli kiertää ympyrää.", "Kun vaihdat toiseen kieleen, peli alkaa uudestaan – automaattinen siirtyminen samalle ruudulle kielen vaihtuessa ", "tässä pelissä ei ole mahdollista.", "", "Aikuisen tehtävä: auttaa lasta", " ja lausua oikein ääneen kuvissa esitetyt sanat.", "Varsinkin ne sanat, jotka eivät vielä ole tuttuja lapselle.", "Pelin aikana lapset oppivat mitä Venäjällä kasvaa ", "ja laajentavat sanastoaan.", "Onnea peliin!"],
            "rus": ["На каждом экране расположены тематические картинки", "и буква русского алфавита,  на которую начинаются слова,", "изображённые на картинках.", "Нажав на любую картинку курсором, узнаешь название слова.", "По стрелочкам «Назад» и «Вперёд» можно перейти на другую букву.", "Не дожидаясь, пока все картинки на одном экране будут открыты. ", "Буквы в игре расположены в произвольном порядке.", "Игра идёт по кругу. При переходе на другой язык игра каждый раз начинается сначала – автоматический переход на тот же самый экран при смене языка в данной игре не предусмотрен.", "", "Задача взрослого: помочь ребёнку ", "и правильно произносить вслух слова, изображённые на картинках. Особенно те слова, которые ещё не знакомы ребёнку.", "В ходе игры дети узнают, что растёт в России, ", "и расширяют свой словарный запас.", " ", "Удачи в игре!"]
        },
        "Continue": { "type": "Button", "fin": "Jatka", "rus": "Продолжить" }
    },
    "fontAllAlphabet": {
        "rus": {
            "А": "1",
            "Е": "1",
            "О": "1",
            "У": "1",
            "И": "1",
            "Ю": "1",
            "Я": "1",
            "Ё": "1",
            "Ы": "1",
            "Э": "1",
            "Ф": "2",
            "Й": "1",
            "Ц": "2",
            "К": "2",
            "Н": "2",
            "Г": "2",
            "Ш": "2",
            "Щ": "2",
            "З": "2",
            "Х": "2", 
            "Ъ": "3",
            "В": "2",
            "П": "2",
            "Р": "2",
            "Л": "2",
            "Д": "2",
            "Ж": "2",
            "Ч": "2",
            "С": "2",
            "М": "2",
            "Ь": "3",
            "Б": "2",
            "Т": "2"
        },
        "fin": {
            "Q": "2",
            "W": "2",
            "E": "1",
            "R": "2",
            "T": "2",
            "Y": "1",
            "U": "1",
            "I": "1",
            "O": "1",
            "P": "2",
            "A": "1",
            "S": "2",
            "D": "2",
            "F": "2",
            "G": "2",
            "H": "2",
            "J": "1",
            "K": "2",
            "L": "2",
            "Ö": "1",
            "Ä": "1",
            "Z": "2",
            "X": "2",
            "C": "2",
            "V": "2",
            "B": "2",
            "N": "2",
            "M": "2"
        }
    },
    "content": {
        "Vishnja": {
            "fin": "Kirsikka",
            "rus": "Вишня"
        },
        "Sliva": {
            "fin": "Luumu",
            "rus": "Слива"
        },
        "Jabloko": {
            "fin": "Omena",
            "rus": "Яблоко"
        },
        "Grusha": {
            "fin": "Päärynä",
            "rus": "Груша"
        },
        "Lilija": {
            "fin": "Lilja",
            "rus": "Лилия"
        },
        "Mimosa": {
            "fin": "Mimoosa",
            "rus": "Мимоза"
        },
        "Astra": {
            "fin": "Asteri",
            "rus": "Астра"
        },
        "Repeinik": {
            "fin": "Takiainen",
            "rus": "Репейник"
        },
        "Klever": {
            "fin": "Apila",
            "rus": "Клевер"
        },
        "Podsolnuh": {
            "fin": "Auringonkukka",
            "rus": "Подсолнух"
        },
        "Vasilek": {
            "fin": "Kaunokki",
            "rus": "Василёк"
        },
        "Landysh": {
            "fin": "Kielo",
            "rus": "Ландыш"
        },
        "Kolokolchik": {
            "fin": "Kissankello",
            "rus": "Колокольчик"
        },
        "Ljupin": {
            "fin": "Lupiini",
            "rus": "Люпин"
        },
        "Narcis": {
            "fin": "Narsissi",
            "rus": "Нарцисс"
        },
        "AnjutinyGlaski": {
            "fin": "Orvokki",
            "rus": "Анютины глазки"
        },
        "Romashka": {
            "fin": "Päivänkakkara",
            "rus": "Ромашка"
        },
        "IvanChay": {
            "fin": "Maitohorsma", 
            "rus": "Иван-чай"
        },
        "Petunija": {
            "fin": "Petunia",
            "rus": "Петуния"
        },
        "Roza": {
            "fin": "Ruusu ",
            "rus": "Роза"
        },
        "Tulpan": {
            "fin": "Tulppaani",
            "rus": "Тюльпан"
        },
        "Oduvanchik": {
            "fin": "Voikukka",
            "rus": "Одуванчик"
        },
        "Goroh": {
            "fin": "Herne",
            "rus": "Горох"
        },
        "Kapusta": {
            "fin": "Kaali",
            "rus": "Капуста"
        },
        "Ogurec": {
            "fin": "Kurkku",
            "rus": "Огурец"
        },
        "Tjikva": {
            "fin": "Kurpitsa",
            "rus": "Тыква"
        },
        "Baklazan": {
            "fin": "Munakoiso",
            "rus": "Баклажан"
        },
        "Perec": {
            "fin": "Paprika",
            "rus": "Перец"
        },
        "Brokkoli": {
            "fin": "Parsakaali",
            "rus": "Брокколи"
        },
        "Kartofel": {
            "fin": "Peruna",
            "rus": "Картофель"
        },
        "Morkov": {
            "fin": "Porkkana",
            "rus": "Морковь"
        },
        "Svekla": {
            "fin": "Punajuuri",
            "rus": "Свёкла"
        },
        "Redis": {
            "fin": "Retiisi",
            "rus": "Редис"
        },
        "Redka": {
            "fin": "Retikka",
            "rus": "Редька"
        },
        "Luk": {
            "fin": "Sipuli",
            "rus": "Лук"
        },
        "Pomidor": {
            "fin": "Tomaatti",
            "rus": "Помидор"
        },
        "Arbuz": {
            "fin": "Vesimeloni",
            "rus": "Арбуз"
        },
        "Podosinovik": {
            "fin": "Haavanpunikkitatti",
            "rus": "Подосиновик"
        },
        "Muhomor": {
            "fin": "Kärpässieni",
            "rus": "Мухомор"
        },
        "Smorchek": {
            "fin": "Korvasieni",
            "rus": "Сморчок"
        },
        "SyroezkaRozovaja": {
            "fin": "Rusohapero",
            "rus": "Сыроежка розовая"
        },
        "Volnushka": {
            "fin": "Karvarousku",
            "rus": "Волнушка"
        },
        "Podberezovik": {
            "fin": "Lehmäntatti",
            "rus": "Подберёзовик"
        },
        "Openok": {
            "fin": "Mesisieni",
            "rus": "Опёнок"
        },
        "SyroezkaChernaja": {
            "fin": "Mustahapero",
            "rus": "Сыроежка чёрная"
        },
        "Borovik": {
            "fin": "Herkkutatti",
            "rus": "Боровик"
        },
        "Lisichka": {
            "fin": "Vahvero",
            "rus": "Лисичка"
        },
        "Rizik": {
            "fin": "Männynleppärousku",
            "rus": "Рыжик"
        },
        "Poganka": {
            "fin": "Myrkkysieni",
            "rus": "Поганка"
        },
        "Svinushka": {
            "fin": "Pulkkosieni",
            "rus": "Свинушка"
        },
        "Dozdevik": {
            "fin": "Tuhkelo",
            "rus": "Дождевик"
        },
        "Maslenok": {
            "fin": "Voitatti",
            "rus": "Маслёнок"
        },
        "Mohovik": {
            "fin": "Kangastatti",
            "rus": "Моховик"
        },
        "Gruzd": {
            "fin": "Koivurousku",
            "rus": "Груздь"
        },
        "Barbaris": {
            "fin": "Happomarja",
            "rus": "Барбарис"
        },
        "Kalina": {
            "fin": "Heisi",
            "rus": "Калина"
        },
        "Kljukva": {
            "fin": "Karpalo",
            "rus": "Клюква"
        },
        "Krizovnik": {
            "fin": "Karviainen",
            "rus": "Крыжовник"
        },
        "Moroshka": {
            "fin": "Lakka",
            "rus": "Морошка"
        },
        "Klubnika": {
            "fin": "Mansikka",
            "rus": "Клубника"
        },
        "Zemljanika": {
            "fin": "Metsämansikka",
            "rus": "Земляника"
        },
        "ChernajaSmorodina": {
            "fin": "Mustaherukka",
            "rus": "Чёрная смородина"
        },
        "ChernoplodnajaRjabina": {
            "fin": "Musta-aronia",
            "rus": "Черноплодная рябина"
        },
        "Chernika": {
            "fin": "Mustikka",
            "rus": "Черника"
        },
        "Rjabina": {
            "fin": "Pihlaja",
            "rus": "Рябина"
        },
        "KrasnajaSmorodina": {
            "fin": "Punaherukka",
            "rus": "Красная смородина"
        },
        "Brusnika": {
            "fin": "Puolukka",
            "rus": "Брусника"
        },
        "Oblepiha": {
            "fin": "Tyrni",
            "rus": "Облепиха"
        },
        "Malina": {
            "fin": "Vadelma",
            "rus": "Малина"
        },
        "Ezevika": {
            "fin": "Vatukka",
            "rus": "Ежевика"
        }
    }
}
export default textContents;